import React from 'react';
import './Pricing.css';

const plans = [
  {
    name: 'Free',
    price: 0,
    description: 'Get started with AI-powered fitness at no cost.',
    cta: 'Start for Free',
    ctaStyle: 'outline',
    features: [
      { text: 'AI-generated training plan (1 block)', included: true },
      { text: 'Basic nutrition guidelines', included: true },
      { text: 'Session tracking & logging', included: true },
      { text: 'Weight progress chart', included: true },
      { text: 'AI Coach chat (limited)', included: true },
      { text: 'Unlimited plan blocks & monthly recalibration', included: false },
      { text: 'Full AI Coach (unlimited messages)', included: false },
      { text: 'Full nutrition plan & meal diary', included: false },
      { text: 'Progress photos & body measurements', included: false },
      { text: 'Advanced analytics & exercise history', included: false },
    ],
  },
  {
    name: 'Pro',
    price: 9.99,
    description: 'Unlock the full FitMind AI experience and never plateau again.',
    cta: 'Start Free Trial',
    ctaStyle: 'primary',
    badge: 'Most Popular',
    features: [
      { text: 'AI-generated training plan (1 block)', included: true },
      { text: 'Basic nutrition guidelines', included: true },
      { text: 'Session tracking & logging', included: true },
      { text: 'Weight progress chart', included: true },
      { text: 'AI Coach chat (limited)', included: true },
      { text: 'Unlimited plan blocks & monthly recalibration', included: true },
      { text: 'Full AI Coach (unlimited messages)', included: true },
      { text: 'Full nutrition plan & meal diary', included: true },
      { text: 'Progress photos & body measurements', included: true },
      { text: 'Advanced analytics & exercise history', included: true },
    ],
  },
];

const Pricing: React.FC = () => {
  return (
    <section className="pricing" id="pricing">
      <div className="container">
        <div className="pricing__header">
          <span className="section-label">Pricing</span>
          <h2 className="section-title">
            Simple, <span>transparent</span> pricing
          </h2>
          <p className="section-subtitle">
            Start free. Upgrade when you're ready to go all-in. Cancel anytime.
          </p>
        </div>

        <div className="pricing__cards">
          {plans.map((plan, i) => (
            <div
              className={`pricing__card${i === 1 ? ' pricing__card--featured' : ''}`}
              key={plan.name}
            >
              {plan.badge && <div className="pricing__badge">{plan.badge}</div>}

              <div className="pricing__plan-name">{plan.name}</div>
              <div className="pricing__price">
                {plan.price === 0 ? (
                  <span className="pricing__amount">Free</span>
                ) : (
                  <>
                    <span className="pricing__currency">$</span>
                    <span className="pricing__amount">{plan.price}</span>
                    <span className="pricing__period">/ month</span>
                  </>
                )}
              </div>

              <p className="pricing__desc">{plan.description}</p>

              <a
                href="#download"
                className={`pricing__cta ${plan.ctaStyle === 'primary' ? 'btn-primary' : 'btn-outline'}`}
              >
                {plan.cta}
              </a>

              <ul className="pricing__features">
                {plan.features.map((f, j) => (
                  <li key={j} className={f.included ? '' : 'pricing__feat--excluded'}>
                    <span className={`pricing__feat-icon ${f.included ? 'pricing__feat-icon--yes' : 'pricing__feat-icon--no'}`}>
                      {f.included ? '✓' : '×'}
                    </span>
                    {f.text}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="pricing__note">
          7-day free trial on Pro. No credit card required to start. Cancel anytime.
        </p>
      </div>
    </section>
  );
};

export default Pricing;
